import { MakeCall } from './createMakeCall';

export type ActivateUserCall = (token: string) => Promise<{ data: null }>;

const activateUser = (makeCall: MakeCall) => (token: string) =>
  makeCall<undefined>('POST', `/api/v2/action/activate`, {
    data: { token },
  });
export { activateUser };
